import React from 'react'
import './Clients.css'

const Clients = () => {
  return (
    <div className='clients'>
        <div className="hl-0"></div>
        <div className="hl-1"></div>
        <div className="hl-2"></div>
        <div className="hl-3"></div>
      <div className="about-clients" id='clients-header'>OUR &nbsp;<span style={{color:'#c5a47e'}}>CLIENTS</span></div>
      <div className="clients-names-wrapper">
        <div className="client-name"><span style={{'zIndex':'1'}}>JLPL</span></div>
        <div className="client-name" style={{'textAlign':'center'}}><span style={{'zIndex':'1'}}>Havells</span></div>
        <div className="client-name" style={{'textAlign':'right'}}><span style={{'zIndex':'1'}}>Mittaso</span></div>
        <div className="client-name"><span style={{'zIndex':'1'}}>HUDA/HSVP</span></div>
        <div className="client-name" style={{'textAlign':'center'}}><span style={{'zIndex':'1'}}>Swami Devi Dayal Group</span></div>
        <div className="client-name" style={{'textAlign':'right'}}><span style={{'zIndex':'1'}}>Green Valley</span></div>
        <div className="client-name"><span style={{'zIndex':'1'}}>Sohi Group</span></div>
        <div className="client-name" style={{'textAlign':'center'}}><span style={{'zIndex':'1'}}>India Cements</span></div>
        <div className="client-name" style={{'textAlign':'right'}}><span style={{'zIndex':'1'}}>HSIIDC</span></div>
        <div className="client-name"><span style={{'zIndex':'1'}}>SP Singla</span></div>
      </div>
    </div>
  )
}

export default Clients
